// ACTION TYPES ($ means that the action updates the state)
const LOGIN_ATTEMPT_WEP = '$user/login_wep/ATTEMPT'
const LOGIN_FAILED_WEP = '$user/login_wep/FAILED'
const LOGIN_SUCCESS = 'user/login/SUCCESS'
const LOGOUT = '$user/LOGOUT'
const AUTHENTICATED_YES = '$user/authenticated/YES'
const AUTHENTICATED_NO = '$user/authenticated/NO'
export const types = Object.freeze({
    LOGIN_ATTEMPT_WEP,
    LOGIN_FAILED_WEP,
    LOGIN_SUCCESS,
    AUTHENTICATED_YES,
    AUTHENTICATED_NO,
    LOGOUT,
})

// ACTIONS
const loginAttemptWEP = ({ email, password }) => {
    return {
        type: LOGIN_ATTEMPT_WEP,
        credentials: {
            email,
            password,
        },
    }
}
const loginFailedWEP = (error) => {
    return {
        type: LOGIN_FAILED_WEP,
        error,
    }
}
const loginSuccess = () => {
    return {
        type: LOGIN_SUCCESS,
    }
}
const authenticatedYes = () => {
    return {
        type: AUTHENTICATED_YES,
    }
}
const authenticatedNo = () => {
    return {
        type: AUTHENTICATED_NO,
    }
}
const logout = () => {
    return {
        type: LOGOUT,
    }
}

export const actions = Object.freeze({
    loginAttemptWEP,
    loginFailedWEP,
    loginSuccess,
    authenticatedYes,
    authenticatedNo,
    logout,
})

// REDUCER
export const defaultState = Object.freeze({
    // authentication happens in 3 steps
    // null = not initialized (initializing)
    // true = authenticathed (firebase properly set)
    // false = not authenticathed (logout/expired/storage removed/etc)
    authenticated: null,
    error: null,
})
export const reducer = (state = defaultState, action) => {
    switch (action?.type) {
        case types.AUTHENTICATED_YES:
            return { ...state, authenticated: true, error: null }

        case types.AUTHENTICATED_NO:
        case types.LOGOUT:
            return { ...state, authenticated: false, error: null }

        case types.LOGIN_ATTEMPT_WEP:
            return { ...state, error: null }

        case types.LOGIN_FAILED_WEP:
            return { ...state, error: action.error }

        default:
            return state
    }
}
